import UserGroupUsersTableHelper from "./usergroup-users-table-helper";
import UserGroupsTableHelper     from "./usergroups-table-helper";
import { canManageUserGroups }   from "./usergroup-access-helper";

const UserGroupHelpers = {
    TableMain  : UserGroupsTableHelper,
    TableUsers : UserGroupUsersTableHelper,
    canManageUserGroups,
}

export default UserGroupHelpers;

export { canManageUserGroups };
